export default __webpack_public_path__ + "static/media/Logo.a2a8fe32.svg";